var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wkb-canvas" },
    [
      _vm.graphLoading
        ? _c(
            "div",
            { staticClass: "wkb-canvas-status wkb-canvas-status--loading" },
            [
              _c("span", {
                staticClass: "wkb-canvas-spinner",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" Building graph… "),
            ]
          )
        : _vm.graphError
        ? _c(
            "div",
            { staticClass: "wkb-canvas-status wkb-canvas-status--error" },
            [_vm._v(" " + _vm._s(_vm.graphError) + " ")]
          )
        : _vm.showCanvasWorkspace
        ? [
            _c(
              "div",
              { staticClass: "wkb-canvas-toolbar" },
              [
                _vm._m(0),
                _c("WorkspaceGraphViewportControls", {
                  attrs: {
                    "zoom-level": _vm.zoomLevel,
                    "graph-table-open": _vm.graphTableOpen,
                    "graph-table-disabled": !_vm.hasGraph,
                    "graph-options-open": _vm.graphOptionsOpen,
                    "hide-contextual-edges": _vm.hideContextualEdges,
                    "hide-jumping-edges": _vm.hideJumpingEdges,
                    "visibility-filter-count": _vm.activeVisibilityFilterCount,
                    "ai-assistant-open": _vm.aiAssistantOpen,
                  },
                  on: {
                    "update:zoomLevel": function ($event) {
                      _vm.zoomLevel = $event
                    },
                    "update:graphTableOpen": function ($event) {
                      _vm.graphTableOpen = $event
                    },
                    "update:graphOptionsOpen": function ($event) {
                      _vm.graphOptionsOpen = $event
                    },
                    "update:hideContextualEdges": function ($event) {
                      _vm.hideContextualEdges = $event
                    },
                    "update:hideJumpingEdges": function ($event) {
                      _vm.hideJumpingEdges = $event
                    },
                    action: function ($event) {
                      return _vm.$emit("graph-action", $event)
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "wkb-canvas-graph-wrap",
                on: { click: _vm.onGraphViewerClick },
              },
              [
                !_vm.hasGraph
                  ? _c(
                      "div",
                      {
                        staticClass: "wkb-canvas-empty",
                        attrs: { role: "status" },
                      },
                      [
                        _c("p", { staticClass: "wkb-canvas-empty-title" }, [
                          _vm._v("Blank canvas"),
                        ]),
                        _vm._m(1),
                      ]
                    )
                  : _vm._e(),
                _vm.graphReminder && !_vm.graphLoading
                  ? _c("WorkspaceGraphReminder", {
                      attrs: { reminder: _vm.graphReminder },
                      on: {
                        action: function ($event) {
                          return _vm.$emit("graph-reminder-action", $event)
                        },
                        dismiss: function ($event) {
                          return _vm.$emit("graph-reminder-dismiss")
                        },
                      },
                    })
                  : _vm._e(),
                _c("WorkspaceTreeGraphCanvas", {
                  ref: "treeGraph",
                  attrs: {
                    "show-empty-message": false,
                    "graph-nodes": _vm.graphNodes,
                    "graph-edges": _vm.graphEdges,
                    "contextual-edges": _vm.contextualEdges,
                    "selected-node-id": _vm.selectedNodeId,
                    "selected-edge-id": _vm.selectedEdgeId,
                    "key-node-ids": _vm.keyNodeIds,
                    "node-ids-with-evidence": _vm.nodeIdsWithEvidence,
                    "edge-keys-with-evidence": _vm.edgeKeysWithEvidence,
                    "zoom-level": _vm.zoomLevel,
                    "hide-contextual-edges": _vm.hideContextualEdges,
                    "hide-jumping-edges": _vm.hideJumpingEdges,
                  },
                  on: {
                    "node-menu-open": function ($event) {
                      return _vm.$emit("node-menu-open", $event)
                    },
                    "edge-menu-open": function ($event) {
                      return _vm.$emit("edge-menu-open", $event)
                    },
                  },
                }),
                _c("WorkspaceInspector", {
                  attrs: {
                    open: _vm.inspectorOpen,
                    "selected-node-id": _vm.selectedNodeId,
                    "selected-edge-id": _vm.selectedEdgeId,
                    "selected-node": _vm.selectedNodeDetail,
                    "selected-edge": _vm.selectedEdgeDetail,
                    "gene-inspector-context": _vm.geneInspectorContext,
                    "trait-inspector-context": _vm.traitInspectorContext,
                    "mechanism-inspector-context":
                      _vm.mechanismInspectorContext,
                    "gene-set-inspector-context": _vm.geneSetInspectorContext,
                    "expression-options": _vm.expressionOptions,
                    "api-client": _vm.apiClient,
                    "graph-busy": _vm.graphBusy,
                    "graph-nodes": _vm.graphNodes,
                    "inspector-content-key": _vm.inspectorContentKey,
                  },
                  on: {
                    toggle: function ($event) {
                      return _vm.$emit("toggle-inspector")
                    },
                    "cache-connections": function ($event) {
                      return _vm.$emit("cache-node-connections", $event)
                    },
                    "cache-expression": function ($event) {
                      return _vm.$emit("cache-node-expression", $event)
                    },
                    "cache-factor-loadings": function ($event) {
                      return _vm.$emit("cache-factor-loadings", $event)
                    },
                    "load-factor-loadings": function ($event) {
                      return _vm.$emit("load-factor-loadings", $event)
                    },
                    "add-node": function ($event) {
                      return _vm.$emit("add-table-node", $event)
                    },
                    "remove-node": function ($event) {
                      return _vm.$emit("remove-table-node", $event)
                    },
                    "inspect-connected-edge": function ($event) {
                      return _vm.$emit("inspect-connected-edge", $event)
                    },
                    "inspect-connected-node": function ($event) {
                      return _vm.$emit("inspect-connected-node", $event)
                    },
                  },
                }),
              ],
              1
            ),
            _c("WorkspaceGraphDataTableModal", {
              attrs: {
                open: _vm.graphTableOpen && _vm.hasGraph,
                "graph-nodes": _vm.allGraphNodes.length
                  ? _vm.allGraphNodes
                  : _vm.graphNodes,
                "graph-edges": _vm.graphEdges,
                "contextual-edges": _vm.contextualEdges,
                "retrieval-ledger": _vm.retrievalLedger,
                "ledger-session": _vm.ledgerSession,
                "key-node-ids": _vm.keyNodeIds,
                "graph-busy": _vm.graphBusy,
              },
              on: {
                close: function ($event) {
                  _vm.graphTableOpen = false
                },
                "add-node": function ($event) {
                  return _vm.$emit("add-table-node", $event)
                },
                "remove-node": function ($event) {
                  return _vm.$emit("remove-table-node", $event)
                },
              },
            }),
          ]
        : _c("div", { staticClass: "wkb-canvas-placeholder" }, [
            _c("div", { staticClass: "wkb-canvas-placeholder-mark" }, [
              _vm._v("KG"),
            ]),
            _c("p", { staticClass: "wkb-canvas-placeholder-title" }, [
              _vm._v("Knowledge graph canvas"),
            ]),
            _vm._m(2),
          ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "wkb-canvas-legend",
        attrs: { "aria-label": "Tree view legend" },
      },
      [
        _c("span", { staticClass: "wkb-canvas-legend-item" }, [
          _c("span", {
            staticClass: "wkb-canvas-swatch wkb-canvas-swatch--key-node",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" Selected node "),
        ]),
        _c("span", { staticClass: "wkb-canvas-legend-item" }, [
          _c("span", {
            staticClass: "wkb-canvas-swatch wkb-canvas-swatch--starting-node",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" Starting node "),
        ]),
        _c("span", { staticClass: "wkb-canvas-legend-item" }, [
          _c("span", {
            staticClass: "wkb-canvas-line wkb-canvas-line--solid",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" Active edges "),
        ]),
        _c("span", { staticClass: "wkb-canvas-legend-item" }, [
          _c("span", {
            staticClass: "wkb-canvas-line wkb-canvas-line--contextual",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" Contextual edges "),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "wkb-canvas-empty-sub" }, [
      _vm._v(" Use "),
      _c("strong", [_vm._v("Expand KG → Add nodes")]),
      _vm._v(" or the "),
      _c("strong", [_vm._v("AI assistant")]),
      _vm._v(" to place entities on the graph. "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "wkb-canvas-placeholder-sub" }, [
      _vm._v(
        " Your graph will appear here. Start by building an initial graph from "
      ),
      _c("strong", [_vm._v("Manage → New graph")]),
      _vm._v(", or open "),
      _c("strong", [_vm._v("My library")]),
      _vm._v(" to load a saved graph. "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }